import { Component, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateOptions, DATE_OPTIONS, AuctionsWalletItem, RewardsWalletQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgbcl-auction-wallet-details',
  templateUrl: './auction-wallet-details.component.html',
  styleUrls: ['./auction-wallet-details.component.scss'],
})
export class AuctionWalletDetailsComponent implements OnInit {
  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private rewardWalletQuery: RewardsWalletQuery,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  @Input() id: string;
  auctionBid$: Observable<AuctionsWalletItem | undefined>;
  screenType = ScreenType;

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id') || '0';
    this.auctionBid$ = this.rewardWalletQuery.selectRewardWalletItem(id).pipe(map((item) => item as AuctionsWalletItem));
  }

  backToWallet() {
    this.location.back();
  }
}
